import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import { ContentBox } from "@portal/kit/pkg/components"
import { SubscriptionContext } from "components/providers/subscription/subscription-provider"

import SubscriptionCard from "./card/subscription-card"

export default function Subscriptions() {
  const { t } = useTranslation()
  const { subscriptions, unsubscribeSubscription } = useContext(SubscriptionContext)

  return (
    <ContentBox title={t('subscription.title')}>
      {subscriptions.map(sub => <SubscriptionCard key={sub.id} subscription={sub} unsubscribeSubscription={unsubscribeSubscription} />)}
    </ContentBox>
  )
}
